import PRODUCT from './productTypes'
import { createActionCreators } from '../utils/actionHelpers'

const {
  fetchProductElementRequest,
  fetchProductElementSuccess,
  fetchProductElementFailure,
  fetchProductSliderRequest,
  fetchProductSliderSuccess,
  fetchProductSliderFailure,
} = createActionCreators(PRODUCT)

export const fetchProductElement = (api, sku) => (dispatch) => {
  dispatch(fetchProductElementRequest({ sku }))
  return api.fetchProductDetail(sku)
    .then(({ data }) => {
      return dispatch(
        fetchProductElementSuccess({
          sku,
          product: data,
        })
      )
    })
    .catch((error) => {
      // console.log('error', error)
      return dispatch(
        fetchProductElementFailure({
          sku,
          error,
        })
      )
    })
}

export const fetchProductSlider = (api, skuList) => (dispatch) => {
  dispatch(fetchProductSliderRequest({ skuList }))
  return api.fetchProductList(skuList)
    .then((products) => {
      return dispatch(
        fetchProductSliderSuccess({
          skuList,
          products,
        })
      )
    })
    .catch((error) => {
      // console.log('error', error)
      return dispatch(
        fetchProductSliderFailure({
          skuList,
          error,
        })
      )
    })
}


// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/redux/product/productActions.js